import firebase from 'firebase/app'
import 'firebase/messaging'

const firebaseConfig = {
  apiKey: process.env?.VUE_APP_FIREBASE_API_KEY || 'AIzaSyADLHLyOHG46he_9n5bIqXXYRcUu_lE2G4',
  authDomain: process.env?.VUE_APP_FIREBASE_AUTH_DOMAIN || 'mesa-3-stg.firebaseapp.com',
  // databaseURL: 'https://mesa-3-stg.firebaseio.com',
  projectId: process.env?.VUE_APP_FIREBASE_PROJECT_ID || 'mesa-3-stg',
  storageBucket: process.env?.VUE_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env?.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || '495512141513',
  appId: process.env?.VUE_APP_FIREBASE_APP_ID || '1:495512141513:web:ebe745ade66a738e9c1718',
  measurementId: process.env?.VUE_APP_FIREBASE_MEASUREMENT_ID || ''
}

let messaging = null
if (
  firebase.messaging.isSupported() &&
  process.env.VUE_APP_ENABLE_FCM_NOTIFICATIONS === 'yes'
) {
  firebase.initializeApp(firebaseConfig)
  messaging = firebase.messaging()
}

export default messaging
